const tokenKey = 'Authorization'

export const getToken = function () {
  return new Promise((resolve) => {
    resolve(localStorage.getItem(tokenKey) || sessionStorage.getItem(tokenKey))
  })
}

export const removeToken = () => {
  localStorage.removeItem(tokenKey)
  sessionStorage.removeItem(tokenKey)
}